import { useLocation, useParams, Outlet } from "react-router-dom"
import { useRoute } from "@hydrologiq/shared/providers/helpers/useRoute"
import { routing } from "./routing"
import { pages } from "./pages"
import Selection, { SelectionItem, SubNavItem } from "@hydrologiq/shared/selection/Selection"
import { useGetCopyHomeRoute } from "@hydrologiq/shared/providers/helpers/useCopy"

function PlannerSelection({ children }: { children?: React.ReactNode }) {
  const { orderId } = useParams()
  const route = useRoute()
  let location = useLocation().pathname

  const sectionPages = pages(location)

  // Create sub-navigation items from sectionPages
  const sectPages = Object.entries(sectionPages.pages)
  const subNavItems: SubNavItem[] = sectPages.length > 1 ? Object.entries(sectionPages.pages).map(([key, value]) => ({
    name: value,
    href: routing(route, location, orderId, false, key),
    disabled: false,
  })) : []

  // Create parents for breadcrumb navigation
  const parents: SelectionItem[] = []

  const { name, path } = useGetCopyHomeRoute()

  const item = undefined

  return (
    <Selection
      sectionHeading={name}
      sectionBase={path}
      item={item}
      parents={parents}
      subNavItems={subNavItems}
      subNavHome={sectionPages.defaultPage}
    >
      {children || <Outlet />}
    </Selection>
  )
}

export default PlannerSelection
